import { resolvePersonTypeByDocument } from 'utils/document';

const verifyUserPermission = ({ permission, arrOfPermissions }) => {
  if (arrOfPermissions)
    return arrOfPermissions.find(e => e.role === permission);
}

const resolvePersonType = ({ taxIdentifier }) => {
  return resolvePersonTypeByDocument(taxIdentifier) || 'PF';
}

export { verifyUserPermission, resolvePersonType };
